import { render, staticRenderFns } from "./OutTipsPopuop.vue?vue&type=template&id=2b5b4efe&scoped=true&"
import script from "./OutTipsPopuop.vue?vue&type=script&lang=ts&"
export * from "./OutTipsPopuop.vue?vue&type=script&lang=ts&"
import style0 from "./OutTipsPopuop.vue?vue&type=style&index=0&id=2b5b4efe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5b4efe",
  null
  
)

export default component.exports